import { request } from 'shared/helpers/sagas'
import {
  pick,
  map,
  omit,
} from 'ramda'
import { axiosInstance } from 'network/apis'


export function fetchSurveyCrowds (surveys) {
  //  const getSurveyCrowd = surveyId => request(`/v1/survey/${surveyId}/crowds`)
  const getSurveyCrowd = {"surveyId":689,"surveyCrowds":[{"surveyId":689,"crowdId":99,"answerRequest":0,"qualHonorarium":null,"answerTotal":0,"surveyTimeStarted":null,"surveyStatus":0,"shcStatus":"unfielded","crowd":{"id":99,"optedOutRespondersCount":0,"typeId":1,"typeDescription":"Custom Crowd","name":"ddss","description":"ddss","subscriptionId":26,"createdBy":123456,"marketId":14,"deleted":false,"andOr":null,"deletedOn":null,"deletedBy":null,"createdOn":"2021-09-23T16:16:26Z","isArchived":false,"validRespondersCount":0,"extendedReachCount":0,"followupRules":[],"lastActivityOn":null,"hasRelatedSurveys":true,"attributes":[]},"vendors":[],"currentShcHonorariumLevel":null,"currentShcHonorariumOptions":["A","B","C","D"]}]}
    //return Promise.all(surveys.map(pipe(prop('id'), getSurveyCrowd)))
return getSurveyCrowd
  }
  
export function putInquiry (subscriptionId, {crowds, ...body}) {
    return request(`/v1/subscription/${subscriptionId}/project/inquiry_preview`,
      'PUT',
      {...body, crowds: map(omit(['difficultyAssessment']), crowds)}
    )
  }
  
export const fetchAvailabilityAndTimeSlots = (projectId) =>{
 return axiosInstance.get(`user/get_all_moderators/${projectId}`, {handlerEnabled: true})
}

export function fetchCrowdableAttributes (id) {
    return fetch(`/v1/market/${id}/crowdable_attributes`)
    .then(response => response.json())
  }
  
export const fetchMarketsWithNpi = () => request('/v1/markets/npi') // soulbe be removed
  
export function putProject (project, payload) {
    return request(`/v1/project/${project.id}?lang=en_us`,
      'PUT',
      Object.assign(pick([
        'id',
        'name',
        'description',
        'subscriptionId',
        'createdOn',
        'createdBy',
        'isPrivate',
        'budget',
        'modifiedOn',
        'modifiedBy',
        'projectStatusId',
        'projectTypeId',
        'completedOn',
      ], project), { ...payload }))
  }
  
export function fetchTimeSlots (projectId) {
    return request(`/v1/project/${projectId}/time_slots`)
  }
  

export const fetchProject = async (projectId) => {
  return await axiosInstance.get(`project/get-project-details/${projectId}`, { handlerEnabled: true }) 
  }
  
export function fetchProjectSurveys (projectId) {
    var survey = {"surveys":[{"id":637,"projectId":140,"subscriptionId":50,"surveyTypeId":9,"languageId":1819,"namePublic":"ddss","namePrivate":"","initialTimeSpan":null,"useCrowdQuotas":false,"openUntil":null,"reopenedOn":null,"startTime":null,"endTime":null,"timeInField":0,"sendReminders":true,"numberOfReminders":2,"remindersIncreasedOn":null,"fieldedBy":null,"pulseId":null,"waveNumber":null,"basisId":null,"createdOn":"2021-09-02T08:39:52Z","reviewedOn":null,"createdBy":123456,"modifiedOn":"2021-09-02T08:39:52Z","ownedBy":123456,"jiraIssueLink":null,"invitationTemplateOverride":null,"reminderTemplateOverride":null,"hasTranslationOverride":false,"pmUserId":null,"thirdPartyExternalId":"","thirdPartySurveyTypeId":-1,"numCompletions":0,"completionsNeeded":5,"numSkipLogic":0,"countryId":null,"isoCode":null,"countryName":null,"languageCode":"en_us","languageName":"English","permissions":{"id":738,"userId":123456,"projectId":140,"canWrite":true},"surveyPricingTypeId":1,"freeScreeners":2,"fixedRate":null,"numQuestions":2,"projectName":"test","hasCrowdScreening":false,"status":{"status":0,"label":"Authoring"},"favorite":false,"waves":[],"parallels":[],"isBasis":false,"translationsSubmittedOn":null,"translationsCompletedOn":null,"numCrowds":1,"schedulerId":463}],"limit":null,"offset":0,"totalCount":1}
    //return request(`/v1/project/${projectId}/surveys`)
    return survey
  }
  
export function putObservers (observers, projectId) {
    return request(`/v1/project/${projectId}/observers?lang=en_us`,
      'PUT',
      { observers }
    )
  }
  
export function postProjectInquiry ({subscriptionId, saveForLater, submitForReview, crowds, ...payload}) {
    return request(
      `/v1/subscription/${subscriptionId}/project/inquiry?saveForLater=${saveForLater}&submitForReview=${submitForReview}`,
      'POST',
      {...payload, crowds: map(omit(['difficultyAssessment']), crowds)}
    )
  }
  
export function putProjectInquiry ({
    crowds,
    projectId,
    saveForLater,
    subscriptionId,
    submitForReview,
    ...payload
  }) {
    return request(
      `/v1/subscription/${subscriptionId}/project/${projectId}/inquiry?saveForLater=${saveForLater}&submitForReview=${submitForReview}`,
      'PUT',
      {...payload, crowds: map(omit(['difficultyAssessment']), crowds)}
    )
  }
  
export function duplicateProjectInquiry ({subscriptionId, projectId}) {
    return request(
      `/v1/subscription/${subscriptionId}/project/${projectId}/duplicateInquiry`,
      'PUT',
      {}
    )
  }
  
export function fetchUsersForProject (projectId) {
   // return request(`/v1/project/${projectId}/users`)
   return {"users":[{"id":123456,"acceptedTerms":false,"acceptedAnyTerms":false,"contactByEmail":true,"contactBySms":null,"country":{"id":641,"isoCode":"US","label":"United States","phoneCode":"1","currency":{"id":1,"countryAttributeId":641,"displayCharacter":"$","code":"USD"}},"customCrowdIds":[2,6,9,12,29,36,38],"email":"romy.khneisser@incrowdnow.com","sms":"","firstName":"romy","lastName":"khneisser","languages":[{"id":1819,"languageId":1,"isoCode":"en_us","label":"English","active":true}],"marketId":14,"optedOut":false,"optedOutReason":null,"optedOutBy":null,"optedOutOn":null,"p2pEnabled":true,"profileImageLink":null,"referredBy":null,"registrationDate":"2021-04-26T11:00:57Z","registrationIp":null,"responderTypeId":13,"responderType":{"id":13,"providerName":"InCrowd Employee","completeUrl":null,"exclusionUrl":null,"overQuotaUrl":null,"screenUrl":null,"transferCredits":false,"redirectsActive":false,"phoneContact":"","emailContact":"","uniqueResponderIds":false},"roles":[{"id":1,"name":"ADMIN"},{"id":2,"name":"RESPONDER"},{"id":3,"name":"SUBSCRIPTION USER"},{"id":10,"name":"SUBSCRIPTION OWNER"},{"id":11,"name":"SUBSCRIPTION ADMIN"}],"subscriptionIds":[25,22,23,27,45,46,50,51],"selfServiceSubscriptionIds":[25,22,46],"surveyCounts":{"created":616,"completed":18,"invited":122,"attempted":66,"screenedOut":3},"thirdPartyResponderId":null,"timeZone":"Asia/Beirut","title":null,"userTypeId":13,"userCommunicationAddresses":[{"id":417,"userId":123456,"transportTypeId":1,"address":"romy.khneisser@incrowdnow.com","contactable":true,"createdOn":"2021-04-26T11:00:57Z","paymentAddress":false}],"validatedOn":"2021-04-21T21:00:00Z","validationStatus":"validated","rewards":{"totalUnpaid":0,"totalEarned":0},"specialties":[],"callCenterId":null,"createdBy":null,"notes":"\n","userImportId":null,"internalReferralProgramEnabledAt":null,"internalReferralShortCode":null,"referralLink":null,"seenReferralPage":false,"qualExclusionReason":null,"qualExclusionReasonId":null,"qualEnabled":true,"intercomHash":"2741988dd28b7e240c0e940081f859e0965d0bfcdaa828d275f52dbc5e258f78","tax":null,"countryMobileIso":"US"}],"offset":0,"limit":null,"totalCount":3}
  }
  

export function deleteStimulusFileFromProject (fileId, projectId) {
    return request(`/v1/interview_media/${projectId}/${fileId}`, 'DELETE')
  }
  
export function requestListMatchCrowds (subscriptionId) {
    return request(`/v1/subscription/${subscriptionId}/crowds?typeId=1&typeId=8&includeMarketName=true`, 'GET')
  }

export const getConferenceLinkDetails = async (payload) => {
 return await axiosInstance.get(`get-conference-link/${payload}`, { handlerEnabled: true })
};

export const postConferenceLinkDetails = async (payload, currentProject) => {
  return axiosInstance.post(`add-conference-link/project/${currentProject.id}/participant_group/${currentProject.participantGroupId}`,
    {
      conferenceLink: payload.editedConferenceLink,
      meetingInformation: Array.from(currentProject.editedMeetingInformationMap.entries()),
      userId: currentProject.userId
    },
    { handlerEnabled: true })
};

export const updateProjectModerators = async (payload, projectId, clientId) => {
 return axiosInstance.post(`project/${projectId}/moderators_reset`, {data : {body :{moderatorIds: payload, flag: 'multi', projectId:projectId, pending: true} , "pathParameters": {project_id: projectId,client_id: clientId}}}, { handlerEnabled: true }) 
  };

export const editConferenceLinkDetails = async (payload) => {
  return axiosInstance.put(`update-conference-link/project/${payload.projectId}/participant-group/${payload.participantGroupId}`,
    {
      conferenceLink: payload.conferenceLink,
      meetingInformation: Array.from(payload.editedMeetingInformationMap.entries()),
      userId: payload.userId
    }, { handlerEnabled: true })
};


export const getLanguageAndLocalizationData = async () => {
  return axiosInstance.get(`MyProxy/translations/get-all-localisations`, {}, { handlerEnabled: true })
};


export const editProjectDetails = async (payload) => {
  if(payload.editedSurveyId){
    return axiosInstance.put(`project/update-external-survey-id/${payload.projectId}`,{externalSurveyId: payload.editedSurveyId }, { handlerEnabled: true })
  } else {
  return axiosInstance.put(`project/update-project-details/${payload.id}`, {handlerEnabled: true})
  }
};

export const getAvModeratorsCount = async (payload) => {
  return axiosInstance.get(`project/get-moderators-count/${payload.id}/sample-size/${payload.sampleSize}`, { handlerEnabled: true }) 
};

export const updateProjectSampleSize = async (payload) => {
  return axiosInstance.put(`project/${payload.id}/update-sample-size`,{sampleSize: payload.sampleSize }, { handlerEnabled: true }) 
};

export const deleteProjectModerator = async (payload, projectId,clientId) => {
   return axiosInstance.post(`project/${projectId}/moderators_reset`, {data : {body :{moderatorIds: [payload], flag: 'single', projectId:projectId, pending: true} , "pathParameters": {project_id: projectId,client_id: clientId}}}, { handlerEnabled: true }) 
};

export const getUnavailableModerators = async (payload) => {
  return axiosInstance.get(`project/${payload.id}/get-unavailable-moderators`, { handlerEnabled: true }) 
};

export const putModeratorTimeRange = async (payload) => {
 return axiosInstance.post(`project/${payload.projectId}/time_range/moderator/${payload.moderatorId}`,{startTime: payload.selectedModeratorTimeRange.startTime, endTime: payload.selectedModeratorTimeRange.endTime, timezone: payload.timezone} ,{ handlerEnabled: true })  
};

export const editInterviewBuffer = async (payload) => {
  return axiosInstance.put(`project/update-project-details/${payload.projectId}`,{ postScreeninBuffer: payload.value} ,{ handlerEnabled: true })
};

export const deleteTranslations = async (payload) => { 
  return axiosInstance.delete(`MyProxy/translations/delete-translation/${payload.projectId}/${payload.translationsToDelete}` ,{ handlerEnabled: true })
};

export const deleteTopicTranslations = async (payload) => { 
  return axiosInstance.delete(`MyProxy/translations/delete-topic-translation/${payload.projectId}/${payload.translationsToDelete}` ,{ handlerEnabled: true })
};

export const getTopicNameDetails = async (projectId) => { 
  return axiosInstance.get(`MyProxy/project/get_topics_by_project/${projectId}` ,{ handlerEnabled: true })
};

export const addTopicNameTranslations = async (payload) => { 
  return axiosInstance.post(`MyProxy/update-topic-translation/${payload.id}` ,{topicInfo: Array.from(payload.editedTopicName.entries()), userId: payload.userId},{ handlerEnabled: true })
};

export default {
    fetchSurveyCrowds,
    putInquiry,
    fetchAvailabilityAndTimeSlots,
    fetchCrowdableAttributes,
    fetchMarketsWithNpi,
    fetchTimeSlots,
    putProject,
    requestListMatchCrowds,
    deleteStimulusFileFromProject,
    fetchUsersForProject,
    duplicateProjectInquiry,
    putProjectInquiry,
    postProjectInquiry,
    putObservers,
    fetchProjectSurveys,
    fetchProject,
    getConferenceLinkDetails,
    postConferenceLinkDetails,
    editConferenceLinkDetails,
    editProjectDetails,
    getAvModeratorsCount,
    updateProjectSampleSize,
    updateProjectModerators,
    deleteProjectModerator,
    getUnavailableModerators,
    putModeratorTimeRange,
    editInterviewBuffer,
    getLanguageAndLocalizationData,
    deleteTranslations,
    deleteTopicTranslations,
    getTopicNameDetails,
    addTopicNameTranslations
}
